export default __webpack_public_path__ + "static/media/ambient-bright-blue-pink.19fa4a4f.jpg";